import {inject, injectable} from "inversify";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";
import {IGameBar} from "data/stores/game_bar/game_bar.store";
import {ILastRoundInfo} from "data/stores/promotion/promotion.store";

export type TGameBarResponse = IApiResponse<{gamebar: IGameBar}>;
export type TLastRoundInfoResponse = IApiResponse<{roundRanking: ILastRoundInfo}>;

export interface IGameBarApiProvider {
	gameBar: (contestId: number) => Promise<AxiosResponse<TGameBarResponse>>;
	lastCompleteRoundInfo: () => Promise<AxiosResponse<TLastRoundInfoResponse>>;
	promotionViewed: () => Promise<AxiosResponse<unknown>>;
}

@injectable()
export class GameBarApiProvider implements IGameBarApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}

	gameBar = (contestId: number) =>
		this._http.get<TGameBarResponse>(`ranking/gamebar/${contestId}`);

	lastCompleteRoundInfo = () =>
		this._http.get<TLastRoundInfoResponse>("ranking/round/last-complete");

	promotionViewed = () => this._http.post("user/promotion-demotion-modal/mark-viewed");
}
